module.exports = __webpack_public_path__ + "static/media/img4-1.bf76f440.png";